(() => {
  if (window.CosmeauV6JuoPresentation) return;

  const observed = new WeakSet();
  let hooksAttached = false;
  let syncing = false;
  let pendingFrame = 0;

  const readAmount = element => {
    const raw = element?.textContent
      ?.replace(/[^0-9,.-]/g, '')
      .replace(/\.(?=\d{3}(?:\D|$))/g, '')
      .replace(',', '.');
    const value = Number(raw);
    return Number.isFinite(value) ? value : 0;
  };

  const readSaving = widget => {
    const discountLabel = widget.querySelector('[part="discount-label"]')?.textContent
      ?.trim()
      .replace(/^[-−]\s*/, '');
    if (discountLabel) return discountLabel;

    const basePrice = readAmount(widget.querySelector('[part~="price--base"]'));
    const subscriptionPrice = readAmount(widget.querySelector('[part="subscription-price"]'));
    if (basePrice > 0 && subscriptionPrice > 0 && subscriptionPrice < basePrice) {
      return `${Math.round((1 - subscriptionPrice / basePrice) * 100)}%`;
    }
    return '';
  };

  const syncScope = scope => {
    const widget = scope.querySelector('#juo-subscription-widget');
    if (!widget) return;

    const title = widget.querySelector('.j-subscription .j-label-inner > span');
    if (!title) return;

    let pill = title.querySelector('.cv6-juo-saving-pill');
    const labelTextNodes = [...title.childNodes].filter(node => node.nodeType === Node.TEXT_NODE);
    const duplicateLabelNodes = [...title.children].filter(node => node !== pill && /^(?:Abonnement\s*)+$/i.test(node.textContent?.replace(/\s+/g, ' ').trim() || ''));
    const titleIsCanonical =
      labelTextNodes.length === 1 &&
      labelTextNodes[0] === title.firstChild &&
      labelTextNodes[0].nodeValue === 'Abonnement' &&
      duplicateLabelNodes.length === 0;
    if (!titleIsCanonical) {
      labelTextNodes.forEach(node => node.remove());
      duplicateLabelNodes.forEach(node => node.remove());
      title.prepend(document.createTextNode('Abonnement'));
    }

    const saving = readSaving(widget);
    if (!saving) {
      pill?.remove();
      return;
    }
    if (!pill) {
      pill = document.createElement('span');
      pill.className = 'cv6-juo-saving-pill';
      title.append(pill);
    }
    const text = `Bespaar ${saving}`;
    if (pill.textContent !== text) pill.textContent = text;

    const slot = widget.querySelector('.j-subscription .j-slot');
    if (!slot) return;
    const benefitCopy = [
      ['Extra korting', 'met een abonnement, betaal met iDEAL, Bancontact, PayPal of CC'],
      ['Flexibel', 'Verwijder, voeg toe, of vervang producten naar wens'],
      ['Makkelijk', 'Altijd op te zeggen of verander bezorgfrequentie']
    ];
    let benefits = slot.querySelector('.cv6-juo-benefits');
    if (!benefits) {
      benefits = document.createElement('ul');
      benefits.className = 'cv6-juo-benefits';
      slot.replaceChildren(benefits);
    }
    const signature = benefitCopy.flat().join('|');
    if (benefits.dataset.copy !== signature) {
      benefits.replaceChildren(...benefitCopy.map(([label, copy]) => {
        const item = document.createElement('li');
        const check = document.createElement('span');
        check.className = 'cv6-juo-benefits__check';
        check.setAttribute('aria-hidden', 'true');
        check.textContent = '✓';
        const content = document.createElement('span');
        const strong = document.createElement('strong');
        strong.textContent = `${label}: `;
        content.append(strong, document.createTextNode(copy));
        item.append(check, content);
        return item;
      }));
      benefits.dataset.copy = signature;
    }
  };

  const syncAll = () => {
    // Prevent MutationObserver feedback loops: our DOM writes re-fire the observer.
    if (syncing) return;
    syncing = true;
    try {
      document.querySelectorAll('[data-cv6-juo-enhance]').forEach(syncScope);
    } finally {
      // Release on next macrotask so nested observer callbacks collapse into one pass.
      setTimeout(() => { syncing = false; }, 0);
    }
  };

  const scheduleSync = scope => {
    if (syncing) return;
    if (pendingFrame) cancelAnimationFrame(pendingFrame);
    pendingFrame = requestAnimationFrame(() => {
      pendingFrame = 0;
      if (scope) syncScope(scope);
      else syncAll();
    });
  };

  const observeScopes = () => {
    document.querySelectorAll('[data-cv6-juo-enhance]').forEach(scope => {
      if (observed.has(scope)) return;
      observed.add(scope);
      new MutationObserver(() => {
        if (syncing) return;
        scheduleSync(scope);
      }).observe(scope, { childList: true, subtree: true, characterData: false });
    });
  };

  const attachHooks = () => {
    if (hooksAttached) return true;
    const hooks = window.juoSubscriptionWidget?.hooks;
    if (!hooks) return false;
    hooksAttached = true;
    hooks.onModeChange(() => scheduleSync());
    hooks.onPriceUpdate(() => scheduleSync());
    scheduleSync();
    return true;
  };

  const boot = () => {
    observeScopes();
    scheduleSync();
    attachHooks();
  };

  window.CosmeauV6JuoPresentation = { sync: syncAll, boot };
  document.addEventListener('juo-subscription-widget:hooks:ready', boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
